import QueryString from "querystring";

export default querystring => {
  const parallelsStr = QueryString.parse(querystring.replace(/^\?/, ""))
    .parallels;
  if (!parallelsStr) {
    return [];
  }
  return parallelsStr.split(",");
};
